import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import paymentDetailsAPI from '../../sources/api/paymentDetailsAPI';

// constants
import { CARD_REPLACE } from '../../constants/paymentDetailsTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { paymentDetailsSchema } from '../../schemas/Normalizr';
import { tooltipEdit } from '../../actions/tooltipActions';

export function* cardReplace(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(CARD_REPLACE, call(paymentDetailsAPI.cardReplace, params), paymentDetailsSchema);
    yield put(tooltipEdit({ id: 'replacing-modal', status: 'success' }));
  } catch (e) {
    yield put(tooltipEdit({ id: 'replacing-modal', status: 'error' }));
    yield put(error(CARD_REPLACE, e));
  } finally {
    yield put(doneIndicator(CARD_REPLACE));
  }
}

export function* watchCardReplace() {
  yield takeEvery(CARD_REPLACE, cardReplace);
}

export default function* root() {
  yield all([
    fork(watchCardReplace)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/paymentDetails/cardReplace.js